<template>
  <div>
    <CommonDialog
      :dialog="dialog"
      :head-text="$t('contacts.detach-user')"
      :content-text="$t('contacts.detach-user-dialog')"
      :confirm-button="{
        text: $t('contacts.detach'),
        icon: 'mdi-link-off'
      }"
      :on-confirm="deleteUser"
      :on-cancel="
        () => {
          dialog = false;
        }
      "
    ></CommonDialog>
    <v-data-table
      :headers="headers"
      :items="users"
      :loading="loading"
      :loading-text="$t(`tables.loading`)"
      hide-default-footer
      no-data-text=""
      :height="isEmpty ? undefined : 'calc(100vh - 362px)'"
      :fixed-header="true"
      class="users"
    >
      <template v-slot:item.name="{ item }">
        <template v-if="item.type === 'newUser'">
          <v-text-field
            ref="email"
            height="42"
            v-model="newUser.email"
            :label="$t('contacts.user-email')"
            :rules="[rules.required, rules.email]"
            v-on:keyup.enter="save()"
          ></v-text-field>
        </template>
        <template v-else>
          {{ item.name }}
        </template>
      </template>
      <template v-slot:item.action="{ item }">
        <template v-if="item.type === 'newUser'">
          <v-btn
            class="ml-2 mb-2 mobile"
            color="primary"
            :loading="loading"
            v-on:click="save()"
          >
            <v-icon>
              mdi-plus
            </v-icon>
            {{ $t(`buttons.create`) }}
          </v-btn>
          <v-icon small class="mr-2 desktop" @click="save()">
            mdi-plus
          </v-icon>
        </template>
        <template v-else>
          <v-btn
            class="ml-2 mb-2 mobile"
            color="primary"
            :loading="loading"
            @click="callDialog(item)"
          >
            <v-icon>
              mdi-trash-can-outline
            </v-icon>
            {{ $t(`buttons.delete`) }}
          </v-btn>
          <v-icon small class="desktop" @click="callDialog(item)">
            mdi-trash-can-outline
          </v-icon>
        </template>
      </template>
      <template v-slot:footer>
        <TableEmptyFooter v-if="isEmpty" can-add></TableEmptyFooter>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { rules } from "./../mixins/rules";
import CommonDialog from "../common/dialogs/CommonDialog";
import TableEmptyFooter from "../common/tables/TableEmptyFooter";
export default {
  name: "AssignedUsersContact",
  props: ["id"],
  mixins: [rules],
  components: { CommonDialog, TableEmptyFooter },
  data: function() {
    return {
      headers: [
        {
          text: this.$i18n.t("contacts.name"),
          align: "left",
          sortable: false,
          value: "name"
        },
        {
          text: this.$i18n.t("contacts.action"),
          value: "action",
          align: "right",
          sortable: false
        }
      ],
      newUser: {
        email: ""
      },
      dialog: false,
      userIdToDelete: 0,
      loading: false
    };
  },
  computed: {
    isEmpty() {
      return !(this.nativeUsers && this.nativeUsers.length) && !this.loading;
    },
    nativeUsers() {
      return this.$store.getters[`contactStore/getUsers`];
    },
    users: {
      get() {
        return [{ type: "newUser" }, ...this.nativeUsers];
      }
    }
  },
  methods: {
    resetNewUser() {
      this.newUser = {
        email: ""
      };
      this.$refs.email.resetValidation();
    },
    save() {
      if (this.$refs.email.validate()) {
        this.loading = true;
        this.$store
          .dispatch("contactStore/addUser", {
            id: this.$props.id,
            email: this.newUser.email
          })
          .finally(() => this.getUsers());
        this.resetNewUser();
      }
    },
    callDialog(user) {
      this.dialog = true;
      this.userIdToDelete = user.id;
    },
    deleteUser() {
      this.dialog = false;
      this.loading = true;
      this.$store
        .dispatch("contactStore/deleteUser", {
          id: this.$props.id,
          user_id: this.userIdToDelete
        })
        .finally(() => this.getUsers());
    },
    getUsers() {
      this.loading = true;
      this.$store
        .dispatch("contactStore/getUsers", { id: this.$props.id })
        .finally(() => (this.loading = false));
    }
  },
  created() {
    this.getUsers();
  }
};
</script>

<style lang="scss" scoped>
.mobile {
  display: none;
}
.desktop {
  display: inline-flex;
}
.users::v-deep .v-data-table__mobile-row:nth-child(2) {
  min-height: 0;
  .mobile {
    display: inline-block;
  }
  .desktop {
    display: none;
  }
  .v-data-table__mobile-row__header {
    display: none;
  }
  .v-data-table__mobile-row__cell {
    width: 100% !important;
    .actions-container {
      width: 100% !important;
    }
  }
}
</style>
